/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real-size on-screen ruler. Calibrate it once to your screen and it stays accurate — measure in cm, mm or inches on desktop, or go full-screen to use your phone's edge as the ruler.`)
};

const es_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una regla en pantalla a tamaño real. Calíbrala una vez y se mantiene precisa — mide en cm, mm o pulgadas en el escritorio, o pasa a pantalla completa para usar el borde de tu móvil como regla.`)
};

const de_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bildschirmlineal in echter Größe. Einmal auf deinen Bildschirm kalibrieren, und es bleibt präzise — miss in cm, mm oder Zoll am Desktop, oder wechsle in den Vollbildmodus, um die Kante deines Smartphones als Lineal zu nutzen.`)
};

const nl_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een liniaal op ware grootte, op je scherm. Kalibreer hem één keer op je scherm en hij blijft nauwkeurig — meet in cm, mm of inches op desktop, of ga naar volledig scherm om de rand van je telefoon als liniaal te gebruiken.`)
};

const fr_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une règle à l'écran en taille réelle. Calibrez-la une fois pour votre écran et elle reste précise — mesurez en cm, mm ou pouces sur ordinateur, ou passez en plein écran pour utiliser le bord de votre téléphone comme règle.`)
};

const it_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un righello sullo schermo a grandezza reale. Calibralo una volta e resta preciso — misura in cm, mm o pollici su desktop, oppure passa a schermo intero per usare il bordo del telefono come righello.`)
};

const pt_br2_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma régua na tela em tamanho real. Calibre uma vez para a sua tela e ela permanece precisa — meça em cm, mm ou polegadas no computador, ou use o modo tela cheia para transformar a borda do celular em régua.`)
};

const pt_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma régua no ecrã em tamanho real. Calibre-a uma vez para o seu ecrã e mantém-se rigorosa — meça em cm, mm ou polegadas no computador, ou passe a ecrã inteiro para usar a extremidade do telemóvel como régua.`)
};

const ja_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面上に実寸表示される定規です。一度画面に合わせて校正すれば正確な状態が保たれます — デスクトップではcm・mm・インチで測定でき、全画面表示にすればスマートフォンの端を定規として使えます。`)
};

const zh_ruler_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一把真实尺寸的屏幕标尺。校准一次即可保持准确——在电脑上用厘米、毫米或英寸测量，或全屏使用手机边缘作为标尺。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_intro", locale)
	if (locale === "en") return en_ruler_intro(inputs)
	if (locale === "es") return es_ruler_intro(inputs)
	if (locale === "de") return de_ruler_intro(inputs)
	if (locale === "nl") return nl_ruler_intro(inputs)
	if (locale === "fr") return fr_ruler_intro(inputs)
	if (locale === "it") return it_ruler_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_intro(inputs)
	if (locale === "pt") return pt_ruler_intro(inputs)
	if (locale === "ja") return ja_ruler_intro(inputs)
	return zh_ruler_intro(inputs)
};